<template>
  <b-form id="privilege-criteria" @submit.prevent="onSubmitForm">
    <b-row>
      <b-col cols="12">
        <b-card no-body class="mb-1">
          <b-card-header>
            <span class="information-header">Criteria</span>
          </b-card-header>
          <div class="px-2">
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-end mt-2 mb-1">
                  <add-button
                    :btn-label="'Add'"
                    @click.native="openCriteriaListModal"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12">
                <overlay-loading :loading="loading.tableData">
                  <template #content>
                    <b-table
                      :fields="fields.criteriaTable"
                      :items="formData.critiriaTable"
                      responsive
                      bordered
                      borderless
                      sticky-header
                      show-empty
                      no-local-sorting
                      class="horoscope-table"
                    >
                      <template #cell(list)="data">
                        <div
                          v-for="(item, index) in data.item.criteria"
                          :key="index + '-list'"
                          class="d-inline-block mr-1 mb-1"
                        >
                          <b-button
                            size="sm"
                            :variant="item.type == 2 ? 'info' : 'light'"
                            pill
                          >
                            {{ item.type == 2 ? item.tier : item.tag }}
                          </b-button>
                        </div>
                        <div v-if="data.item.type == 1">
                          <div class="d-inline-block mr-1 mb-1">
                            <b-button size="sm" :variant="'light'" pill>
                              All
                            </b-button>
                            <div class="d-inline-block mr-1 mb-1">
                              <b-button size="sm" :variant="'info'" pill>
                                All
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template #cell(criteria)="data">
                        <div class="d-table">
                          <div class="d-table-row">
                            <div class="d-table-cell text-right">Point</div>
                            <div class="d-table-cell text-center px-2">
                              {{ data.item.point }}
                            </div>
                          </div>
                          <div class="d-table-row">
                            <div class="d-table-cell text-right">
                              Visibility
                            </div>
                            <div class="d-table-cell text-center px-2">
                              <b-button
                                :variant="
                                  data.item.isvisible ? 'success' : 'danger'
                                "
                                class="btn-icon rounded-circle btn-xxs"
                                @click="() => {}"
                              >
                                <feather-icon
                                  :icon="
                                    data.item.isvisible ? 'CheckIcon' : 'XIcon'
                                  "
                                />
                              </b-button>
                            </div>
                          </div>
                          <div class="d-table-row">
                            <div class="d-table-cell text-right">Issuable</div>
                            <div class="d-table-cell text-center px-2">
                              <b-button
                                :variant="
                                  data.item.isissuable ? 'success' : 'danger'
                                "
                                class="btn-icon rounded-circle btn-xxs"
                                @click="() => {}"
                              >
                                <feather-icon
                                  :icon="
                                    data.item.isissuable ? 'CheckIcon' : 'XIcon'
                                  "
                                />
                              </b-button>
                            </div>
                          </div>
                          <div class="d-table-row">
                            <div class="d-table-cell text-right">
                              Redeemable
                            </div>
                            <div class="d-table-cell text-center px-2">
                              <b-button
                                :variant="
                                  data.item.isredeemable ? 'success' : 'danger'
                                "
                                class="btn-icon rounded-circle btn-xxs"
                                @click="() => {}"
                              >
                                <feather-icon
                                  :icon="
                                    data.item.isredeemable
                                      ? 'CheckIcon'
                                      : 'XIcon'
                                  "
                                />
                              </b-button>
                            </div>
                          </div>
                        </div>
                      </template>

                      <template #cell(updatedtime)="data">
                        <div>
                          {{
                            data.item.updatedtime
                              ? resolveDate(data.item.updatedtime) +
                                " " +
                                resolveTime(data.item.updatedtime)
                              : "-"
                          }}
                        </div>
                      </template>

                      <template #cell(actions)="data">
                        <div class="d-flex justify-content-center">
                          <b-button
                            variant="secondary"
                            class="banner-action mr-2"
                            @click="
                              openCriteriaListModal(
                                data.item.criteria_group_id,
                                true
                              )
                            "
                          >
                            <edit-icon
                              class="banner-group-action-svg iconEdit-btn"
                            />
                          </b-button>
                          <b-button
                            variant="secondary"
                            class="banner-action mr-2"
                            @click="openDeleteWarningModal(data.item)"
                          >
                            <delete-icon class="banner-group-action-svg" />
                          </b-button>
                        </div>
                      </template>
                      <template #table-busy>
                        <overlay-loading :loading="true" />
                      </template>
                      <template #empty>
                        <card-no-item :text-no-img="'Item Not Found'" />
                      </template>
                    </b-table>
                  </template>
                </overlay-loading>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mb-3">
                <pagination-with-reorder
                  entity-editable
                  :pagination="pagination"
                  @entityChange="onFilterEntity"
                  @pageChange="onPageChange"
                />
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <manage-criteria-list-modal
      v-if="modalType.manageCriteriaList"
      :is-edit="isEditCriteria"
      :form-data-obj="criteriaDetailItem"
      @onSubmit="saveCriteriaList"
      @onCloseModal="closeManageCriteriaListModal"
    />
    <div class="privilege-btn-wrp mt-2 mb-2">
      <div class="d-flex justify-content-center">
        <cancel-button
          class="mr-1"
          :btn-label="'Back'"
          @click.native="$emit('onPreviousStep')"
          stageBack
        />
        <!-- <save-button
          :type="'submit'"
          class="ml-1"
          :btn-label="'Finish'"
          @click.native="$router.push('/privilege/list')"
        /> -->
        <save-button
          :type="'submit'"
          class="ml-1"
          :btn-label="'Next'"
          @click.native="$emit('onNextStep')"
        />
      </div>
    </div>
  </b-form>
</template>

<script>
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import Ripple from "vue-ripple-directive";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import ManageCriteriaListModal from "./modal/ManageCriteriaListModal.vue";
import usePrivilegeCriteria from "../hooks/usePrivilegeCriteria";

export default {
  directives: {
    Ripple,
  },
  components: {
    EditIcon,
    DeleteIcon,
    CardNoItem,
    ManageCriteriaListModal,
    PaginationWithReorder,
  },
  props: {
    isEdit: { type: Boolean, default: false },
    privilegeId: { type: Number, default: 0 },
  },
  setup(props) {
    const {
      loading,
      formData,
      fields,
      isEditCriteria,
      modalType,
      pagination,
      paginationInfo,
      criteriaDetailItem,
      openCriteriaListModal,
      openDeleteWarningModal,
      closeManageCriteriaListModal,
      saveCriteriaList,
      onSubmitForm,
      resolveDate,
      resolveTime,
      onPageChange,
      onFilterEntity,
    } = usePrivilegeCriteria(props);

    return {
      loading,
      formData,
      fields,
      isEditCriteria,
      modalType,
      pagination,
      paginationInfo,
      criteriaDetailItem,
      openCriteriaListModal,
      openDeleteWarningModal,
      closeManageCriteriaListModal,
      saveCriteriaList,
      onSubmitForm,
      resolveDate,
      resolveTime,
      onPageChange,
      onFilterEntity,
    };
  },
};
</script>
